// extracted by mini-css-extract-plugin
export default {"pageContainer":"documentationPage_pageContainer__wVuaC"};